import { Phrase } from './phrase.class';
import { PhraseVersion } from './phrase-version.class';

import { Required } from '@decorators/entity-required.decorator';
import { Primary } from '@decorators/entity-primary.decorator';

export enum PhraseCategoryType {
	INVESTIGATION = 'investigation',
	CONCLUSION = 'conclusion',
	REMARQUESCONSTATATIONS = 'remarquesconstatations',
}

export class PhraseCategory {
	@Required
	@Primary
	id: number;

	@Required
	label: string;

	phrases: Phrase[];

	@Required
	version: PhraseVersion;

	@Required
	type: PhraseCategoryType;

	@Required
	sort: number;
}
